import { IState } from "@/types/IState";

export default {
    getMinutes: (state: IState) => {
        return Math.floor(state.totalTime / 60);
    },

    getSeconds: (state: IState) => {
        return state.totalTime % 60;
    },

    getPaddingTime: (state: IState) => (time: number) => {
        return (time < 10 ? "0" : "") + time;
    },

    getMinutesWithPadding: (state: IState, getters: any) => {
        return getters.getPaddingTime(getters.getMinutes);
    },

    getSecondsWithPadding: (state: IState, getters: any) => {
        return getters.getPaddingTime(getters.getSeconds);
    },

    getDisplayTime: (state: IState, getters: any) => {
        const minutes = getters.getMinutesWithPadding;
        const seconds = getters.getSecondsWithPadding;
        return `${minutes}:${seconds}`;
    },
};
